import $ from "jquery";
import Panzoom from "@panzoom/panzoom";
import anime from "animejs/lib/anime.es.js";
import tippy from "tippy.js";
if (document.getElementById("twinpigsMap")) {
  const elem = document.getElementById("twinpigsMap");
  // const zoomInButton = document.getElementById('zoomInButton')
  // const zoomOutButton = document.getElementById('zoomOutButton')
  // const resetButton = document.getElementById('resetButton')
  const rangeInput = document.getElementById("rangeInput");
  const atrakcjeTp = document.getElementById("atrakcje");
  const before = document.getElementById("before");
  const after = document.getElementById("after");
  const plus_after = document.getElementById("plus_after");
  const minus_before = document.getElementById("minus_before");

  function atrakcje() {
    const svg = document.getElementsByClassName("twinpigsMapSVG")[0];

    // console.log(svg.classList.contains('d-block') )
    if (svg.classList.contains("d-block") == true) {
      $(".twinpigsMapSVG").removeClass("d-block");
      $(".twinpigsMapSVG").addClass("d-none");
      // console.log(svg)
      $('div[class^="twinpigsMapTooltip"]').hide();
      $('div[class^="sectionPinsImgPointer"]').removeClass("d-none");
    } else {
      $(".twinpigsMapSVG").removeClass("d-none");
      $(".twinpigsMapSVG").addClass("d-block");
      // console.log(svg),
      $('div[class^="twinpigsMapTooltip"]').show();
      $('div[class^="sectionPinsImgPointer"]').addClass("d-none");
    }
  }

  function before1() {
    // console.log(svg.classList.contains('d-block') )

    $(".twinpigsMapSVG").removeClass("d-none");
    $(".twinpigsMapSVG").addClass("d-block");
    // console.log(svg),
    $('div[class^="twinpigsMapTooltip"]').show();
    $('div[class^="sectionPinsImgPointer"]').addClass("d-none");
  }

  function after1() {
    $(".twinpigsMapSVG").removeClass("d-block");
    $(".twinpigsMapSVG").addClass("d-none");
    // console.log(svg)
    $('div[class^="twinpigsMapTooltip"]').hide();
    $('div[class^="sectionPinsImgPointer"]').removeClass("d-none");
  }

  const scale = 1;
  const x = 1;
  const y = 1;

  const panzoom = Panzoom(elem, {
    // setTransform: (elem, { scale, x, y }) => {
    //     panzoom.setStyle('transform', `rotate(0.5turn) scale(${scale}) translate(${x}px, ${y}px)`)
    //   }
  });
  plus_after.addEventListener("click", panzoom.zoomIn);
  minus_before.addEventListener("click", panzoom.zoomOut);
  rangeInput.addEventListener("input", (event) => {
    panzoom.zoom(event.target.valueAsNumber);
  });
  // zoomInButton.addEventListener('click', panzoom.zoomIn)
  // zoomOutButton.addEventListener('click', panzoom.zoomOut)
  // resetButton.addEventListener('click', panzoom.reset)
  atrakcjeTp.addEventListener("click", function() {
    atrakcje();
  });
  after.addEventListener("click", function() {
    var input = $("label.switch").find("input#atrakcje1");
    $(input).prop("checked", true);
    after1();
    $("#before").css("opacity", "0.5");
    $("#after").css("opacity", "1");
  });
  before.addEventListener("click", function() {
    var input = $("label.switch").find("input#atrakcje1");
    // var input = $('label.switch').find('input#atrakcje');
    $(input).prop("checked", false);
    $("#rangeInput").val(1);
    before1();
    $("#before").css("opacity", "1");
    $("#after").css("opacity", "0.5");
    setTimeout(() => panzoom.pan(0, 0));
    panzoom.zoom(1, { animate: true });
  });

  elem.addEventListener("panzoomchange", (event) => {
    /* console.log(event.detail) // => { x: 0, y: 0, scale: 1 } */
  });

  if ($("label.switch").hasClass("selected")) {
    // var switchStatus = true;
    var input = $("label.switch").find("input#atrakcje1");
    var cord_x = $("#twinpigsMap").attr("data-cords-x");
    var cord_y = $("#twinpigsMap").attr("data-cords-y");
    var zoom = $("#twinpigsMap").attr("data-zoom");
    //   var after_styled = $('#atrakcje');
    $(input).prop("checked", true);
    setTimeout(() => panzoom.pan(cord_x, cord_y));
    panzoom.zoom(zoom, { animate: true });
    $("#before").css("opacity", "0.5");
    $("#after").css("opacity", "1");
    atrakcje();

    //   console.log(cord_x)
  } else {
    $(input).prop("checked", false);
    $("#before").css("opacity", "1");
    $("#after").css("opacity", "0.5");
  }

  // img SVG convert to SVG code if class .svg
  $("img.svg").each(function() {
    var $img = jQuery(this);
    var imgID = $img.attr("id");
    var imgClass = $img.attr("class");
    var imgURL = $img.attr("src");

    $.get(
      imgURL,
      function(data) {
        var $svg = $(data).find("svg");
        if (typeof imgID !== "undefined") {
          $svg = $svg.attr("id", imgID);
        }
        if (typeof imgClass !== "undefined") {
          $svg = $svg.attr("class", imgClass + " replaced-svg");
        }
        $svg = $svg.removeAttr("xmlns:a");
        if (
          !$svg.attr("viewBox") &&
          $svg.attr("height") &&
          $svg.attr("width")
        ) {
          $svg.attr(
            "viewBox",
            "0 0 " + $svg.attr("height") + " " + $svg.attr("width")
          );
        }
        $img.replaceWith($svg);
      },
      "xml"
    );
  });

  var timeLine = anime.timeline();

  timeLine
    .add({
      targets: ".homeSliderLogo img",
      opacity: ["1", "0"],
      scale: 0,
      duration: 0,
    })
    .add({
      targets: ".homeSliderStars img",
      opacity: ["1", "0"],
      scale: 0,
      duration: 0,
    })
    .add({
      targets: ".homeSliderHero img",
      opacity: ["1", "0"],
      scale: 0,
      duration: 0,
    })
    .add({
      targets: ".homeSliderTitle",
      opacity: ["1", "0"],
      scale: 0,
      duration: 0,
    })
    .add({
      targets: ".homeSliderArrow",
      opacity: ["1", "0"],
      scale: 0,
      duration: 0,
    });

  var timeLine2 = anime.timeline();
  timeLine2
    .add({
      targets: ".homeSliderLogo img",
      opacity: ["0", "1"],
      scale: 1,
      duration: 700,
      offset: "2000",
    })
    .add({
      targets: ".homeSliderStars img",
      opacity: ["0", "1"],
      scale: 1,
      duration: 700,
      offset: "2200",
    })
    .add({
      targets: ".homeSliderHero img",
      opacity: ["0", "1"],
      scale: 1,
      duration: 700,
      offset: "2100",
    })
    .add({
      targets: ".homeSliderTitle",
      opacity: ["0", "1"],
      scale: 1,
      duration: 700,
      offset: "2900",
    })
    .add({
      targets: ".homeSliderArrow",
      opacity: ["0", "1"],
      scale: 1,
      duration: 200,
      offset: "3300",
    });

  anime({
    targets: ".svgAnimateSun img",
    rotate: [
      {
        duration: 36000,
        value: 180,
      },
    ],
    loop: true,
    easing: "linear",
  });
  anime({
    targets: ".svgAnimateSun",
    translateX: [
      {
        duration: 36000,
        value: ["0", "-10vw"],
      },
      {
        duration: 36000,
        value: ["-10vw", "0"],
      },
    ],
    loop: true,
    easing: "linear",
  });
  anime({
    delay: 5000,
    targets: ".svgAnimateCloud1",
    translateX: [
      {
        duration: 90000,
        value: [0, "100vw"],
      },
      {
        duration: 0,
        value: ["100vw", "0"],
      },
      {
        delay: 50,
        duration: 90000,
        value: [0, "100vw"],
      },
      {
        duration: 0,
        value: ["100vw", "0"],
      },
    ],
    translateY: [
      {
        duration: 0,
        value: ["0", "20vw"],
      },
      {
        duration: 90000,
        value: ["20vw", "55vw"],
      },
      {
        duration: 0,
        value: ["0", "20vw"],
      },
      {
        duration: 90000,
        value: ["20vw", "10vw"],
      },
      {
        duration: 0,
        value: ["10vw", "0"],
      },
    ],
    opacity: [
      {
        duration: 0,
        value: ["1", "0"],
      },
      {
        duration: 2000,
        value: ["0", "1"],
      },
      {
        delay: 35000,
        duration: 2000,
        value: ["1", "0"],
      },
      {
        delay: 60000,
        duration: 2000,
        value: ["0", "1"],
      },
      {
        delay: 65000,
        duration: 2000,
        value: ["1", "0"],
      },
    ],
    loop: true,
    easing: "linear",
  });
  anime({
    delay: 15000,
    targets: ".svgAnimateCloud2",
    translateX: [
      {
        duration: 90000,
        value: ["0", "-100vw"],
      },
      {
        duration: 0,
        value: ["-100vw", "0"],
      },
    ],
    translateY: [
      {
        duration: 90000,
        value: ["0", "10vw"],
      },
      {
        duration: 0,
        value: ["10vw", "0"],
      },
    ],
    opacity: [
      {
        duration: 0,
        value: ["1", "0"],
      },
      {
        duration: 3000,
        value: ["0", "1"],
      },
      {
        delay: 50000,
        duration: 2000,
        value: ["1", "0"],
      },
    ],
    loop: true,
    easing: "linear",
  });
  anime({
    delay: 38000,
    targets: ".svgAnimateBird1",
    translateX: [
      {
        duration: 50000,
        value: ["0", "100vw"],
      },
      {
        duration: 0,
        value: ["100vw", "0"],
      },
      {
        delay: 5000,
        duration: 50000,
        value: ["0", "100vw"],
      },
      {
        duration: 0,
        value: ["100vw", "0"],
      },
    ],
    translateY: [
      {
        duration: 50000,
        value: ["0", "50vw"],
      },
      {
        duration: 0,
        value: ["50vw", "20vw"],
      },
      {
        duration: 50000,
        value: ["20vw", "45vw"],
      },
      {
        duration: 0,
        value: ["45vw", "0"],
      },
    ],
    opacity: [
      {
        duration: 0,
        value: ["1", "0"],
      },
      {
        duration: 2000,
        value: ["0", "1"],
      },
      {
        delay: 32000,
        duration: 2000,
        value: ["1", "0"],
      },
      {
        delay: 25000,
        duration: 2000,
        value: ["0", "1"],
      },
      {
        delay: 20000,
        duration: 2000,
        value: ["1", "0"],
      },
    ],
    loop: true,
    easing: "linear",
  });
  anime({
    delay: 8000,
    targets: ".svgAnimateBird2",
    translateX: [
      {
        duration: 50000,
        value: ["0", "-100vw"],
      },
      {
        duration: 0,
        value: ["-100vw", "0"],
      },
      {
        delay: 5000,
        duration: 50000,
        value: ["0", "-100vw"],
      },
      {
        duration: 0,
        value: ["-100vw", "0"],
      },
    ],
    translateY: [
      {
        duration: 0,
        value: ["0", "25vw"],
      },
      {
        duration: 50000,
        value: ["25vw", "65vw"],
      },
      {
        duration: 0,
        value: ["65vw", "0vw"],
      },
      {
        delay: 5000,
        duration: 50000,
        value: ["0", "50vw"],
      },
      {
        duration: 0,
        value: ["50vw", "0"],
      },
    ],
    opacity: [
      {
        duration: 0,
        value: ["1", "0"],
      },
      {
        duration: 2000,
        value: ["0", "1"],
      },
      {
        delay: 15000,
        duration: 2000,
        value: ["1", "0"],
      },
      {
        delay: 40000,
        duration: 2000,
        value: ["0", "1"],
      },
      {
        delay: 28000,
        duration: 2000,
        value: ["1", "0"],
      },
    ],
    loop: true,
    easing: "linear",
  });
  $(window).on("load", function() {
    var count = $(".zoneList a").length;
    $(".zoneList a").each(function(i) {
      //   console.log(this)
      if (typeof $(this).attr("id") != "undefined") {
        var result = $(".twinpigsMapSVG #" + $(this).attr("id"))
          .attr("data-name", $(this).attr("data-name"))
          .attr("data-href", $(this).attr("data-href"));
        /* console.log(result) */
      }
      if (i + 1 === count) {
      }
    });

    $("#us-map polygon, #us-map path").click(function(e) {
      e.stopPropagation();
      if (
        typeof $(this).attr("data-href") !== typeof undefined &&
        $(this).attr("data-href") !== false
      ) {
        window.location.href = $(this).attr("data-href");
      }
    });

    $("#us-map polygon, #us-map path").hover(function(e) {
      $("#info-box").css("display", "block");
      $("#info-box").html($(this).data("name"));
      $(".twinpigsMapTooltip").css("opacity", "0");
      $("." + $(this).attr("id")).css("opacity", "1");
      $(".maps1").css("opacity", "1");
      $(".twinpigsMapTooltip." + $(this).attr("id")).css(
        "margin-bottom",
        "50px"
      );
      $(".animationSvgHide").addClass("animationSvgOpacity");
      $(".animationSvg.animation-" + $(this).attr("id")).addClass(
        "animationSvgZindex"
      );
      setTimeout(function() {
        $(".twinpigsMapTooltip").css("margin-bottom", "0");
      }, 300);
      $(".svgAnimate").addClass("svgAnimateHide");
    });

    $("#us-map polygon, #us-map path").mouseleave(function(e) {
      $("#info-box").css("display", "none");
      $(".maps-point").css("opacity", "0");
      $(".twinpigsMapTooltip").css("opacity", "1");
      $(".svgAnimate").removeClass("svgAnimateHide");
      $(".animationSvgHide").removeClass("animationSvgOpacity");
      $(".animationSvg").removeClass("animationSvgZindex");
    });

    anime({
      targets: ".twinpigsMapTooltipAnimate",
      translateY: 50,
      translateX: ["-50%", "-50%"],
      loop: true,
      duration: 500,
      direction: "alternate",
      easing: "easeInOutCirc",
    });

    var twinpigsMap = $("#twinpigsMap").position();
    $(document)
      .mousemove(function(e) {
        $("#info-box").css(
          "top",
          e.pageY - $("#info-box").height() - 30 - twinpigsMap.top
        );
        $("#info-box").css(
          "left",
          e.pageX - $("#info-box").width() / 2 - twinpigsMap.left
        );
      })
      .mouseover();

    var ios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if (ios) {
      $("a").on("click touchend", function() {
        var link = $(this).attr("href");
        window.open(link, "_blank");
        return false;
      });
    }
    // }, 8000);
  });
  // });
  // Animate tolltip
  // $('.twinpigsMapTooltip').addClass('twinpigsMapTooltipActive');
  // if($("body").hasClass("post-type-archive-mapa")) {
  setTimeout(function() {
    $(".twinpigsMapTooltip").each(function(index) {
      (function(that, i) {
        var t = setTimeout(function() {
          $(that).removeClass("twinpigsMapTooltipActive");
        }, 300 * i);
      })(this, index);
    });
  }, 100);
  // }

  // Mapa Animacje
  function stepAnimation(targets) {
    var steps = $(targets).attr("data-width") / $(targets).attr("data-height");
    $(targets)
      .css("padding-bottom", $(targets).attr("data-height") + "px")
      .css("background-size", steps * 100 + "%")
      .width($(targets).attr("data-height") * steps);

    anime({
      targets: targets,
      backgroundPosition: ["0", "100%"],
      duration: $(targets).attr("data-time"),
      loop: true,
      easing: "steps(" + (steps - 1) + ")",
    });

    var dataStartSize = $(targets).attr("data-start-size");
    $(targets)
      .css("width", Math.round($(".twinpigsMapBox1").width() / dataStartSize))
      .css(
        "padding-bottom",
        Math.round($(".twinpigsMapBox1").width() / dataStartSize)
      );
    $(window).resize(function() {
      $(targets)
        .css("width", Math.round($(".twinpigsMapBox1").width() / dataStartSize))
        .css(
          "padding-bottom",
          Math.round($(".twinpigsMapBox1").width() / dataStartSize)
        );
    });
  }

  stepAnimation(".animationHawaje");
  stepAnimation(".animationLasPrzygod1");
  stepAnimation(".animationLasPrzygod2");
  stepAnimation(".animationLasPrzygod3");
  stepAnimation(".animationPowrot1");
  stepAnimation(".animationPowrot2");
  stepAnimation(".animationLasVegas");
}
// const template = document.getElementById('template');
// tippy('.tippy-popover', {
//     theme: 'atrakcje',
//     maxWidth: 250,
//     // content: template.innerHTML,
//   });

//   $('.tippy-popover').each(function(){
//     tippy(this, {
//         theme: 'atrakcje',
//         maxWidth: 250,
//         content: document.querySelector('#tooltip_content').cloneNode(true)
//     });
// });

tippy(".tippy-popover", {
  content(reference) {
    const id = reference.getAttribute("data-template");
    const container = document.createElement("div");
    const linkedTemplate = document.getElementById(id);
    const node = document.importNode(linkedTemplate.content, true);
    container.appendChild(node);
    return container;
  },
  theme: "atrakcje",
  maxWidth: 250,
});
